// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2dbc896b] .pub_dialog {\n  z-index: 99 !important;\n}\n.tox-tinymce-aux[data-v-2dbc896b] {\n  z-index: 5000 !important;\n}\n.sketch_content[data-v-2dbc896b] {\n  overflow: auto;\n  height: 434px;\n  padding: 0px 30px 11px 27px;\n}\n", ""]);
// Exports
module.exports = exports;
